exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".select-option-link{color:#23c0d2}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-form/reservation-form.component.css"],"names":[],"mappings":"AAAA,oBACE,aAAe,CAChB","file":"reservation-form.component.css","sourcesContent":[".select-option-link {\n  color: #23C0D2;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-form/reservation-form.component.css
// module id = /Ynw
// module chunks = 0